import { RadioButtonGroup, RadioButton } from "@octopusdeploy/design-system-components";
import * as React from "react";
import type { ActionEditProps } from "~/components/Actions/pluginRegistry";
import { ProducerSuppliedFormSection } from "~/components/form/Sections/index";
import { Note, Summary } from "~/components/form/index";
import { ValueInPropertiesOrErrorsHasChanged } from "~/utils/ShouldUpdate/ValueInPropertiesHasChanged";
const StringProperties = {
    "Octopus.Action.PowerShell.Edition": "",
};
type SelectPowerShellEditionProperties = {
    [P in keyof typeof StringProperties]: string;
};
export default class SelectPowerShellEditionReadOnly extends React.Component<ActionEditProps<SelectPowerShellEditionProperties>> {
    shouldComponentUpdate(nextProps: ActionEditProps<SelectPowerShellEditionProperties>) {
        return ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    }
    summary() {
        const edition = this.props.properties["Octopus.Action.PowerShell.Edition"] || "";
        const summary = [];
        edition === "" ? summary.push(<span>Please select the edition of PowerShell</span>) : summary.push(<span>{edition === "Core" ? "PowerShell Core" : "Windows PowerShell (Desktop)"} will be used during Windows deployments</span>);
        return Summary.summary(React.Children.toArray(summary));
    }
    render() {
        const psEdition = this.props.properties["Octopus.Action.PowerShell.Edition"] || "Desktop";
        return (<ProducerSuppliedFormSection isExpandedByDefault={this.props.expandedByDefault} errorKey="Octopus.Action.PowerShell.Edition" title="PowerShell Edition" summary={this.summary()} help="Please select the PowerShell edition used during Windows deployments">
                <RadioButtonGroup value={psEdition} onChange={(e) => this.props.setProperties({ ["Octopus.Action.PowerShell.Edition"]: e })}>
                    <RadioButton value="Desktop" label="Windows PowerShell (Desktop)" key="Desktop"/>
                    <RadioButton value="Core" label="PowerShell Core" key="Core"/>
                </RadioButtonGroup>
                <Note>
                    <p>For non-Windows deployments PowerShell Core will be used</p>
                </Note>
            </ProducerSuppliedFormSection>);
    }
    static displayName = "SelectPowerShellEditionReadOnly";
}
